import React, { useEffect } from 'react';
import { HelmetProvider } from 'react-helmet-async';
import ReactGA from 'react-ga';
import './App.css';
import Profile from './Profile/Profile';
import DarkModeToggle from './components/DarkModeToggle/DarkModeToggle';

const App: React.FC = () => {
    useEffect(() => {
        ReactGA.initialize('G-JKHD2P7CW3');
        ReactGA.pageview('/');
    }, []);

    return (
        <HelmetProvider>
            <DarkModeToggle />
            <Profile />
        </HelmetProvider>
    );
};

export default App;
